// COMPONENTS
import Row from "./row.customizableTable";

// CONSTANTS
import { TEST_DATA } from "./constants/testData.constant";
import { DEFAULT_COLUMNS } from "./constants/defaultColumns.constant";
import ResizableHeader from "./headers/resizable.header";

const DEFAULT_CLASSNAMES = {
  table: "bg-slate-100 rounded border-separate shadow shadow-black ",
  thead: "z-20 bg-slate-200 sticky top-0",
  headerRow: "",
  headerCell: "px-4 py-2",
  tbody: "",
  tr: "bg-slate-100 h-[55px]",
  tr2: "bg-gray-300 h-[55px]",
  bodyCell: "text-center px-4 py-2",
};

const Table = ({
  sortProps = { sort: "", handleSort: () => {} },
  getFormProps = () => {},
  classNames = DEFAULT_CLASSNAMES,
  header = null,
  body = null,
  data = TEST_DATA,
  columnProps = { columns: DEFAULT_COLUMNS, hanldeResize: () => {} },
  changeHandlers = {
    selectAllHandler: () => {},
    handleSelect: () => {},
    handleChange: () => {},
    handleMultiSelectChange: () => {},
    handleSearch: () => {},
  },
  select = false,
  selectAll = false,
  selectedItems = [],
}) => {
  const filteredColumns = columnProps.columns?.filter((column) => column?.show);

  return (
    <table className={classNames?.table || DEFAULT_CLASSNAMES.table}>
      <thead className={classNames?.thead || DEFAULT_CLASSNAMES.thead}>
        {header || (
          <tr className={classNames?.headerRow || DEFAULT_CLASSNAMES.headerRow}>
            {select && (
              <th className="max-w-[45px]">
                <input
                  className="checked:accent-primary w-[45px]"
                  type="checkbox"
                  onChange={changeHandlers?.selectAllHandler}
                  checked={selectAll}
                />
              </th>
            )}
            {filteredColumns?.map((column) => (
              <ResizableHeader
                sortProps={sortProps}
                handleResize={columnProps.handleResize}
                column={column}
                key={column?.id}
              >
                {column?.label}
              </ResizableHeader>
            ))}
          </tr>
        )}
      </thead>
      <tbody className={classNames?.tbody || DEFAULT_CLASSNAMES.tbody}>
        {body ||
          (data &&
            data?.map((item, index) => (
              <Row
                columns={filteredColumns}
                key={`${item?._id}-${index}`}
                changeHandlers={changeHandlers}
                getFormProps={getFormProps}
                data={item}
                select={select}
                checked={
                  !!selectedItems?.find(
                    (selectedItem) => selectedItem?._id === item?._id
                  )
                }
                classNames={{
                  tr:
                    index % 2 === 0
                      ? DEFAULT_CLASSNAMES.tr
                      : DEFAULT_CLASSNAMES.tr2,
                }}
              />
            )))}
      </tbody>
    </table>
  );
};

export default Table;
